import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";
import { Lock } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const getToken = () => localStorage.getItem("farmsons_admin_token");

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  if (getToken()) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await axios.post(`${API}/auth/login`, { email, password });
      localStorage.setItem("farmsons_admin_token", data.token);
      toast.success("Welcome back.");
      navigate("/admin");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[var(--cream)] px-6">
      <form data-testid="admin-login-form" onSubmit={submit} className="w-full max-w-sm bg-white border border-[#1d3a1f]/10 rounded-2xl p-8 card-soft">
        <div className="flex items-center gap-2 text-[#d3a53a]"><Lock size={18} /><span className="text-xs font-bold uppercase tracking-[0.15em]">Inquiry Inbox</span></div>
        <h1 className="mt-3 font-display font-extrabold text-2xl text-[#1d3a1f]">Admin sign in</h1>
        <label className="block mt-6 text-xs font-bold uppercase tracking-[0.12em] text-[#5f6b57]">Email
          <input data-testid="admin-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required
            className="mt-2 w-full border-b border-[#1d3a1f]/20 bg-transparent py-2.5 text-[#1d3a1f] focus:outline-none focus:border-[#d3a53a]" />
        </label>
        <label className="block mt-5 text-xs font-bold uppercase tracking-[0.12em] text-[#5f6b57]">Password
          <input data-testid="admin-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required
            className="mt-2 w-full border-b border-[#1d3a1f]/20 bg-transparent py-2.5 text-[#1d3a1f] focus:outline-none focus:border-[#d3a53a]" />
        </label>
        <button data-testid="admin-login-submit" type="submit" disabled={loading}
          className="mt-8 w-full bg-[#d3a53a] text-[#173a1e] font-bold py-3.5 rounded-full hover:bg-[#b98a26] transition-colors duration-200 disabled:opacity-60">
          {loading ? "Signing in..." : "Sign in"}
        </button>
      </form>
    </div>
  );
}
